import { BrowserRouter, Routes, Route } from "react-router-dom";

import './App.css';
import Dev from './components/Dev/Dev.jsx';
import NavBar from './components/NavBar/NavBar.jsx';
import TheVoid from './components/TheVoid/TheVoid.jsx';
import AskUsAndSupport from './components/AskUsAndSupport/AskUsAndSupport.jsx';
import Privacy from "./components/Privacy/Privacy";
import LoginRegister from "./components/AccountManagement/LoginRegister.jsx";
import Logout from "./components/AccountManagement/Logout.jsx";
import IntroWithConsent from "./components/IntroWithConsent/IntroWithConsent.jsx";
import StudyTwoIntroSessionOnward from "./components/StudyTwoInstructions/StudyTwoIntroSessionOnward.jsx";
import PostSurvey from "./components/PostSurvey/PostSurvey.jsx"

import StudyTwoSummary from "./components/StudyTwo/StudyTwoSummary.jsx";
import StudyOne from "./components/StudyOne/StudyOne.jsx";
import StudyTwo from "./components/StudyTwo/StudyTwo.jsx";

function App() {
  const enableCombinedExperience = true;
  const enableDarkModetoggle = false;

  return (
    <>
      <BrowserRouter>
        <NavBar
          enableCombinedExperience={enableCombinedExperience} 
          enableDarkModetoggle={enableDarkModetoggle}   
        />
        <Routes>
          <Route exact path="/dev" element={<Dev/>}/>

          <Route exact path="/" element={<IntroWithConsent/>}/>
          <Route exact path="/home" element={<IntroWithConsent/>}/>
          <Route exact path="/login_register" element={<LoginRegister/>}/>
          <Route exact path="/logout" element={<Logout/>}/>
          <Route path="/ask_us" element={<AskUsAndSupport/>}/>
          <Route path="/privacy" element={<Privacy/>}/>

          <Route exact path="/intro" element={<IntroWithConsent/>}/>
          <Route exact path="/study_one" element={<StudyOne/>}/>

          <Route exact path="/discussion" element={<StudyTwoIntroSessionOnward/>}/>

          <Route exact path="/explore" element={<StudyTwo/>}/>
          <Route exact path="/exploration_summary" element={<StudyTwoSummary/>}/>
          <Route exact path="/post_survey" element={<PostSurvey/>}/>
          
          <Route path="*" element={<TheVoid/>} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;